export default function Style(){
  return (
    <style>
      {`
       .title_head {
  font-family: 'Fjalla One';
  color: #1b1b1b;
  font-size: 44px;
  line-height: 55px;
}
.hello_disc {
  font-family: 'Josefin Sans' !important;
  color: #5e5e5e;
}

.hello {
  font-family: 'Josefin Sans' !important;
  color:#5e5e5e;
}

        `}
    </style>
  );
}
